(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us"] && !Shopify.designMode) return;
  try {
    
      const contact_form_button = document.querySelector('#contact_form_button');
      const contact_page = document.querySelector('#contact-page');
      contact_form_button.addEventListener('click', function () {
        contact_page.classList.toggle('hidden');
      });
    
  } catch(e) { console.error(e); }
})();
})();
